module.exports = __webpack_public_path__ + "static/media/chestHeightMale.5823982b.png";